const url = 'https://nonsonnalue.vercel.app'


 const gotoPortfolio = () => {
    window.open(url, 'Portfolio')
}

export default gotoPortfolio